__turbopack_context__.v({
  "--1": "photo-flow-entry-module-scss-module__47J9qG__--1",
  "--2": "photo-flow-entry-module-scss-module__47J9qG__--2",
  "--3": "photo-flow-entry-module-scss-module__47J9qG__--3",
  "--grid": "photo-flow-entry-module-scss-module__47J9qG__--grid",
  "--is-entry": "photo-flow-entry-module-scss-module__47J9qG__--is-entry",
  "--is-selected": "photo-flow-entry-module-scss-module__47J9qG__--is-selected",
  "--is-submission": "photo-flow-entry-module-scss-module__47J9qG__--is-submission",
  "--masonry": "photo-flow-entry-module-scss-module__47J9qG__--masonry",
  "__attribute": "photo-flow-entry-module-scss-module__47J9qG____attribute",
  "__button-on-image": "photo-flow-entry-module-scss-module__47J9qG____button-on-image",
  "__buttons": "photo-flow-entry-module-scss-module__47J9qG____buttons",
  "__buttons-container": "photo-flow-entry-module-scss-module__47J9qG____buttons-container",
  "__footer": "photo-flow-entry-module-scss-module__47J9qG____footer",
  "__image": "photo-flow-entry-module-scss-module__47J9qG____image",
  "__image-container": "photo-flow-entry-module-scss-module__47J9qG____image-container",
  "__overlay": "photo-flow-entry-module-scss-module__47J9qG____overlay",
  "__overlay-text": "photo-flow-entry-module-scss-module__47J9qG____overlay-text",
  "__rank-display": "photo-flow-entry-module-scss-module__47J9qG____rank-display",
  "__selected-vote-icon": "photo-flow-entry-module-scss-module__47J9qG____selected-vote-icon",
  "__title": "photo-flow-entry-module-scss-module__47J9qG____title",
  "photo-flow-entry": "photo-flow-entry-module-scss-module__47J9qG__photo-flow-entry",
  "shimmer": "photo-flow-entry-module-scss-module__47J9qG__shimmer",
});
